import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AuthGuard } from "../app/services/auth.guard";
import { UsuarioService } from './services/usuario.service';
import { ExcelService } from './services/excel.service';

import { environment } from './../environments/environment';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { NgxSpinnerModule } from "ngx-spinner";
import { HttpModule } from '@angular/http';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';

import { DefaultModule } from './layouts/default/default.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgmCoreModule } from '@agm/core';

//Pages
import { LoginComponent } from './login/login.component';
import { AlertaVersaoComponentDialog } from './modules/dialogs/versao-minima-dialog/versao-minima-dialog';
import { AlertaManutencaoDialog } from './modules/dialogs/manutencao-dialog/manutencao-dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SicoobService } from './services/sicoob';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AlertaVersaoComponentDialog,
    AlertaManutencaoDialog
  ],
  imports: [
    BrowserModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBLhdcuvEPFwKz0gQHWvAFcl-rkL_JTSrE'
    }),
    AppRoutingModule,
    BrowserAnimationsModule,
    DefaultModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireFunctionsModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    HttpModule,
    NgbModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    HttpClientModule
  ],
  providers: [AuthGuard, UsuarioService, ExcelService, SicoobService],
  bootstrap: [AppComponent]
})
export class AppModule { }
